import "./Skills.scss";    
 
import _skillList from "./skills.json";    
 

interface ISkill {
  [key: string]: {
    description : string,
    color : string
    logo  ?: string // The path to the logo image (optional)
  } | undefined
};

export const skillsList : ISkill = _skillList;


export function Skill({children} : {children : string}) { 
  const skillName = children;
  const skill = skillsList[skillName];
 
  
  if (skill === undefined) throw new Error(`Undefined skill name : "${skillName}"`);

  let logo = <></>; 
  if (skill.logo !== undefined) {
    logo = <img className="logo" src={skill.logo} alt="java logo"/>
  }
  
  return (<span className="skill" style={{ backgroundColor : skill.color }}>  
            <span>{skillName}</span>
            <span className="tooltip" style={{ borderColor : skill.color }}>
              {skill.description}
              {logo}
            </span>
          </span>);
}


export function Skills({ names } : {names : string[]}) {
  
  return (<ul className="skills">
    {names.map( (names, i) => 
      <li key={i}>
        <Skill>{names}</Skill>
      </li>
    )}  
  </ul>);
}
